import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import ContainerCss from "../../containers.module.css";
import InfoStyle from "./informacoes.module.css";

import BackgroundSistema from "../../background/BackSistema";
import BarraLateral from "../../barra-lateral/BarraLateral";
import Notifica from "../../sino-notificacao/Notificacao";
import BtnVoltar from "../../btn-voltar/BotaoVoltar";

// Imports dos Inputs para Pessoa
import Nome from "../../inputs-cadastro/Nome";
import Email from "../../inputs-cadastro/Email";
import Cpf from "../../inputs-cadastro/Cpf";
import Rg from "../../inputs-cadastro/Rg";
import Telefone from "../../inputs-cadastro/Telefone";
import DtNasc from "../../inputs-cadastro/DtNasc";
import Genero from "../../inputs-cadastro/Genero";
import DC from "../../inputs-cadastro/DestroCanhoto";
import Text from "../../inputs-cadastro/TextPadrao";

// Imports do Endereço
import Cep from "../../inputs-cadastro/endereco/Cep";
import UF from "../../inputs-cadastro/endereco/Uf";
import Cidade from "../../inputs-cadastro/endereco/Cidade";
import Bairro from "../../inputs-cadastro/endereco/Bairro";
import Rua from "../../inputs-cadastro/endereco/Rua";

// Formatações
function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR", { timeZone: "UTC" }); // Formato DD/MM/YYYY
}

function formatCPF(cpf) {
    if (!cpf) return "";
    return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

function formatRG(rg) {
    if (!rg) return "";
    return rg.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
}

function formatTelefone(telefone) {
    if (!telefone) return "";
    return telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
}

export default function Tela_Info_Aluno() {
    const navigate = useNavigate();
    const { id_aluno } = useParams();

    // Estados do aluno
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [cpf, setCpf] = useState("");
    const [rg, setRg] = useState("");
    const [telefone, setTelefone] = useState("");
    const [nascimento, setNascimento] = useState("");
    const [cadastro, setCadastro] = useState("");
    const [genero, setGenero] = useState("");
    const [mao_dominante, setMao_Dominante] = useState("");
    const [tipoPlano, setTipoPlano] = useState("");
    const [diaPagamento, setDiaPagamento] = useState("");

    // Estados do endereço
    const [cep, setCep] = useState("");
    const [uf, setUf] = useState("");
    const [cidade, setCidade] = useState("");
    const [bairro, setBairro] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [turmas, setTurmas] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);

    const preencherDados = useCallback(async () => {
        try {
            const response = await axios.get(`/api/aluno/allData/${id_aluno}`);
            const dados = response.data[0];

            // Aluno
            setNome(dados.nome_aluno || "");
            setEmail(dados.email_aluno || "");
            setCpf(formatCPF(dados.cpf_aluno));
            setGenero(dados.genero_aluno || "");
            setRg(formatRG(dados.rg_aluno));
            setTelefone(formatTelefone(dados.telefone_aluno));
            setNascimento(formatDate(dados.data_nascimento_aluno));
            setCadastro(formatDate(dados.dt_inicio));
            setMao_Dominante(dados.destro_canhoto || "");
            setTipoPlano(dados.tipo_plano || "");
            setDiaPagamento(dados.dia_pagamento || "");

            // Endereço
            setCep(dados.cep_aluno || "");
            setLogradouro(dados.rua_aluno || "");
            setBairro(dados.bairro_aluno || "");
            setCidade(dados.cidade_aluno || "");
            setUf(dados.estado_aluno || "");
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    }, [id_aluno]);

    const buscarTurmas = useCallback(async () => {
        try {
            const response = await axios.get(`/api/aluno/turmas/${id_aluno}`);
            setTurmas(response.data);
        } catch (error) {
            console.error("Erro ao buscar turmas:", error);
        }
    }, [id_aluno]);

    const buscarResponsaveis = useCallback(async () => {
        try {
            const response = await axios.get(`/api/aluno/responsaveis/${id_aluno}`);
            setResponsaveis(response.data);
        } catch (error) {
            console.error("Erro ao buscar responsáveis:", error);
        }
    }, [id_aluno]);

    useEffect(() => {
        if (id_aluno) {
            preencherDados();
            buscarTurmas();
            buscarResponsaveis();
        }
    }, [id_aluno, preencherDados, buscarTurmas, buscarResponsaveis]);

    return (
        <div>
            <BackgroundSistema />
            <div className={ContainerCss.container}>
                <BarraLateral />
                <div className={InfoStyle.content}>
                    <div className={InfoStyle.textcenter}>
                        <h1>Informações Do Aluno</h1>
                    </div>
                    <form className={InfoStyle.form}>
                        <div className={InfoStyle.contentInputs}>
                            <Nome value={nome} readOnly />
                            <Email value={email} readOnly />
                            <Cpf value={cpf} readOnly />
                            <Rg value={rg} readOnly />
                            <Telefone value={telefone} readOnly />
                            <DtNasc value={nascimento} readOnly />
                            <DtNasc texto={true} value={cadastro} readOnly />
                            <Genero value={genero} disabled />
                            <DC value={mao_dominante} disabled />
                            {/* Endereço */}
                            <Cep value={cep} readOnly />
                            <UF value={uf} readOnly />
                            <Cidade value={cidade} readOnly />
                            <Bairro value={bairro} readOnly />
                            <Rua value={logradouro} readOnly />
                            <br />
                            <Text texto={"Tipo de Plano"} value={tipoPlano} readOnly />
                            <Text texto={"Dia de Pagamento"} value={diaPagamento} readOnly />
                        </div>
                        <div className={InfoStyle.divLista}>
                            <label className={InfoStyle.label}><b>
                                Número de Turmas: {turmas.length}
                            </b></label>
                            <ul className={InfoStyle.lista}>
                                {turmas.map((turma) => (
                                    <li key={turma.id_turma} onClick={() => navigate(`/aulas/turma/${turma.id_turma}`)} style={{ cursor: 'pointer' }}>
                                        {turma.nome_turma}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className={InfoStyle.divLista}>
                            <label className={InfoStyle.label}><b>
                                Número de Responsáveis: {responsaveis.length}
                            </b></label>
                            <ul className={InfoStyle.lista}>
                                {responsaveis.map((responsavel) => (
                                    <li key={responsavel.id_pessoa} onClick={() => navigate(`/adm/InformaçõesDoResponsavel/${responsavel.id_pessoa}`)} style={{ cursor: 'pointer' }}>
                                        {responsavel.nome_pessoa}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </form>
                </div>
                <Notifica />
                <BtnVoltar />
            </div>
        </div>
    );
}